var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaskicon3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#FFEDD5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.68 30L24 25.68L28.32 30L30 28.32L25.68 24L30 19.68L28.32 18L24 22.32L19.68 18L18 19.68L22.32 24L18 28.32L19.68 30ZM24 36C22.34 36 20.78 35.685 19.32 35.055C17.86 34.425 16.59 33.57 15.51 32.49C14.43 31.41 13.575 30.14 12.945 28.68C12.315 27.22 12 25.66 12 24C12 22.34 12.315 20.78 12.945 19.32C13.575 17.86 14.43 16.59 15.51 15.51C16.59 14.43 17.86 13.575 19.32 12.945C20.78 12.315 22.34 12 24 12C25.66 12 27.22 12.315 28.68 12.945C30.14 13.575 31.41 14.43 32.49 15.51C33.57 16.59 34.425 17.86 35.055 19.32C35.685 20.78 36 22.34 36 24C36 25.66 35.685 27.22 35.055 28.68C34.425 30.14 33.57 31.41 32.49 32.49C31.41 33.57 30.14 34.425 28.68 35.055C27.22 35.685 25.66 36 24 36ZM24 33.6C26.68 33.6 28.95 32.67 30.81 30.81C32.67 28.95 33.6 26.68 33.6 24C33.6 21.32 32.67 19.05 30.81 17.19C28.95 15.33 26.68 14.4 24 14.4C21.32 14.4 19.05 15.33 17.19 17.19C15.33 19.05 14.4 21.32 14.4 24C14.4 26.68 15.33 28.95 17.19 30.81C19.05 32.67 21.32 33.6 24 33.6Z",
    fill: "#EA580C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskicon3);
export default __webpack_public_path__ + "static/media/taskicon3.261d648f6d84bb1ee9b51a99696302ab.svg";
export { ForwardRef as ReactComponent };